import { render, staticRenderFns } from "./Resumen.vue?vue&type=template&id=1dd5ba16&"
import script from "./Resumen.vue?vue&type=script&lang=ts&"
export * from "./Resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports